import React from "react";
import { IconProps } from "./IconProps";

const CaretCircleRightIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          className="caret-circle"
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background rect */}
          <rect
            className="bg"
            x="3"
            y="3"
            width="26"
            height="26"
            rx="13"
            fill="transparent"
          />

          <path
            d="M28.75 16C28.75 13.4783 28.0022 11.0132 26.6012 8.91648C25.2002 6.81976 23.209 5.18556 20.8792 4.22054C18.5495 3.25552 15.9859 3.00303 13.5126 3.49499C11.0393 3.98695 8.76751 5.20127 6.98439 6.98439C5.20127 8.76751 3.98695 11.0393 3.49499 13.5126C3.00302 15.9859 3.25552 18.5495 4.22053 20.8792C5.18555 23.209 6.81975 25.2003 8.91648 26.6012C11.0132 28.0022 13.4783 28.75 16 28.75C19.3803 28.746 22.621 27.4015 25.0112 25.0112C27.4015 22.621 28.746 19.3803 28.75 16ZM4.75 16C4.75 13.775 5.4098 11.5999 6.64597 9.74984C7.88213 7.89979 9.63914 6.45785 11.6948 5.60636C13.7505 4.75487 16.0125 4.53209 18.1948 4.96617C20.3771 5.40025 22.3816 6.47171 23.955 8.04505C25.5283 9.6184 26.5998 11.623 27.0338 13.8052C27.4679 15.9875 27.2451 18.2495 26.3936 20.3052C25.5422 22.3609 24.1002 24.1179 22.2502 25.354C20.4001 26.5902 18.225 27.25 16 27.25C13.0173 27.2467 10.1578 26.0604 8.0487 23.9513C5.93963 21.8422 4.75331 18.9827 4.75 16ZM14.53 21.53C14.4613 21.6037 14.3785 21.6628 14.2865 21.7038C14.1945 21.7448 14.0952 21.7668 13.9945 21.7686C13.8938 21.7704 13.7938 21.7518 13.7004 21.7141C13.607 21.6764 13.5222 21.6203 13.451 21.549C13.3797 21.4778 13.3236 21.393 13.2859 21.2996C13.2482 21.2062 13.2296 21.1062 13.2314 21.0055C13.2332 20.9048 13.2552 20.8055 13.2962 20.7135C13.3372 20.6215 13.3963 20.5387 13.47 20.47L17.9387 16L13.47 11.53C13.3375 11.3878 13.2654 11.1998 13.2688 11.0055C13.2723 10.8112 13.351 10.6258 13.4884 10.4884C13.6258 10.351 13.8112 10.2723 14.0055 10.2688C14.1998 10.2654 14.3878 10.3375 14.53 10.47L19.53 15.47C19.6704 15.6106 19.7493 15.8013 19.7493 16C19.7493 16.1988 19.6704 16.3894 19.53 16.53L14.53 21.53Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default CaretCircleRightIcon;
